import { LinearProgress } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigation } from "react-router-dom"
import { GlobalLoadingStyle } from "@app/components/GlobalLoadingStyle/GlobalLoadingStyle"

/** A page whose code is already cached opens in a few milliseconds: no indicator flashes for it. */
export const NAVIGATION_PROGRESS_DELAY_MS = 200

/**
 * While the router waits for the code of the next page (routes declared with `lazy`), the previous page stays on
 * screen: a bar at the top and the wait cursor tell the user the click was taken into account.
 */
export function NavigationProgress(): React.JSX.Element | null {
  const isNavigating = useNavigation().state !== "idle"
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    if (!isNavigating) {
      setIsShown(false)
      return undefined
    }
    const timeout = setTimeout(() => setIsShown(true), NAVIGATION_PROGRESS_DELAY_MS)
    return () => clearTimeout(timeout)
  }, [isNavigating])

  if (!isShown) {
    return null
  }

  return (
    <>
      <GlobalLoadingStyle isLoading />
      <LinearProgress
        aria-label="Chargement de la page"
        sx={{ position: "fixed", top: 0, left: 0, right: 0, height: 3, zIndex: (theme) => theme.zIndex.tooltip + 1 }}
      />
    </>
  )
}
